import PortfolioBlock from "../PortfolioBlock/PortfolioBlock";

function PortfolioList({ portfolios, onRemove, setEditItem, onEdit, ...props }) {
    return (
        <div {...props} >
            {portfolios && portfolios.map((item) => (
                <PortfolioBlock
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    description={item.description}
                    role={item.role}
                    setEditItem={setEditItem}
                    media={item.media}
                    media2={item.media2}
                    media3={item.media3}
                    media4={item.media4}
                    media5={item.media5}
                    onRemove={onRemove}
                    onEdit={onEdit} // Pass the onEdit callback
                />
            ))}
        </div>
    );
}


export default PortfolioList;
